import React from 'react';
import Header from '../components/header/header';
import './layout.css';

const Layout = (props) => {  
  return (
    <div className="layout">
      <Header/>
      <div className="main">
          {props.children}
      </div>
    </div>
  );
}

export default Layout;